export default __webpack_public_path__ + "static/media/play-image.400c37b2.png";